import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { INumericValidationHandler, TValidatorError } from '../../model';
import { ValidationPatterns } from '../validation-patterns';

export function numericValidator(args: INumericValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const matchNumeric = value.toString().match(ValidationPatterns.numeric);

    if (!matchNumeric?.length) {
      const vldResponse: TValidatorError = { numeric: value };
      return vldResponse;
    }

    return null;
  };
}
